import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import FormBase from "../../../../forms/FormBase";
import PersonalDataForm from "../../../../forms/shared/PersonalDataForm";

import { OrgaoEmissorOptions } from "../../../../data/OrgaoEmissor";

import DadosPessoaisService from "../../../../services/PersonalDataService";
import Controls from "../../../../components/controls/Controls";
import { InputType } from "../../../../components/controls/Input";
import { InputPhoneType } from "../../../../components/controls/PhoneInput";


interface PersonalDataComponentProps {
    PersonalDataForm: PersonalDataForm,
    onInputChange: (name: string, form: FormBase, value: any) => void
}

/* eslint-disable no-useless-escape */
export default function PersonalDataComponent(props: PersonalDataComponentProps) {


    const [civilStateOptions, setCivilStateOptions] = useState([])
    const [languageStateOptions, setLanguageStateOptions] = useState([])

    useEffect(() => {
        DadosPessoaisService.getAllMaritalStatusOptions().then(e => setCivilStateOptions(e))
        DadosPessoaisService.getAllLanguageOptions().then(e => setLanguageStateOptions(e))
    }, []);


    return (

        <Grid container spacing={5}>
            <Grid item xs={12} sm={12}>
                <Controls.Input
                    name="Name"
                    label="Nome completo *"
                    maxLength={60}
                    placeholder="Digite o seu nome completo"
                    value={props.PersonalDataForm.Name.Value}
                    onChange={(e) => {
                        e.target.value = e.target.value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '');
                        props.onInputChange("Name", props.PersonalDataForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("Name", props.PersonalDataForm, e.target.value);
                    }}
                    error={props.PersonalDataForm.Name.Error}
                />
            </Grid>

            <Grid item xs={6} sm={6}>
                <Controls.Input
                    name="CRM"
                    label="Número do Conselho *"
                    maxLength={20}
                    placeholder="Digite o número do conselho"
                    value={props.PersonalDataForm.CRM.Value}
                    onChange={(e) => {
                        e.target.value = e.target.value.replace(/[`~!@#$%^&*()_|+\=?;:'",¨<>\{\}\[\]\\\/]/gi, '');
                        props.onInputChange("CRM", props.PersonalDataForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("CRM", props.PersonalDataForm, e.target.value);
                    }}
                    error={props.PersonalDataForm.CRM.Error}
                />
            </Grid>

            <Grid item xs={6} sm={6}>
                <Controls.DatePicker
                    name="BirthDate"
                    maxDate={new Date()}
                    label="Data de Nascimento *"
                    value={props.PersonalDataForm.BirthDate.Value}
                    onChange={(e) => {
                        props.onInputChange("BirthDate", props.PersonalDataForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("BirthDate", props.PersonalDataForm, e.target.value);
                    }}
                    error={props.PersonalDataForm.BirthDate.Error}
                />
            </Grid>

            <Grid item xs={6} sm={6}>
                <Controls.Input
                    name="RG"
                    label="RG *"
                    maxLength={15}
                    placeholder={"Digite o Número do RG"}
                    value={props.PersonalDataForm.RG.Value}
                    onChange={(e) => {
                        e.target.value = e.target.value.replace(/[`~!@#$%^&*()_|+\=?;:'",¨<>\{\}\[\]\\\/]/gi, '');
                        props.onInputChange("RG", props.PersonalDataForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("RG", props.PersonalDataForm, e.target.value);
                    }}
                    error={props.PersonalDataForm.RG.Error}
                />
            </Grid>


            <Grid item xs={6} sm={6}>
                <Controls.Autocomplete
                    label="Orgão Emissor *"
                    name="OM"
                    placeholder="Digite o órgão emissor"
                    options={OrgaoEmissorOptions}
                    maxLength={40}
                    value={props.PersonalDataForm.OM.Value}
                    onChange={(e) => {
                        props.onInputChange("OM", props.PersonalDataForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("OM", props.PersonalDataForm, e.target.value);
                    }}
                    error={props.PersonalDataForm.OM.Error}
                />
            </Grid>

            <Grid item xs={6} sm={6}>
                <Controls.Input
                    name="CPF"
                    label="CPF *"
                    type={InputType.CPF}
                    maxLength={14}
                    placeholder={"___.___.___-__"}
                    value={props.PersonalDataForm.CPF.Value}
                    onChange={(e) => {
                        props.onInputChange("CPF", props.PersonalDataForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("CPF", props.PersonalDataForm, e.target.value);
                    }}
                    error={props.PersonalDataForm.CPF.Error}
                />
            </Grid>

            <Grid item xs={6} sm={6}>
                <Controls.Autocomplete
                    label="Estado Civil *"
                    name="MaritalStatus"
                    placeholder="Selecione"
                    options={civilStateOptions}
                    value={props.PersonalDataForm.MaritalStatus.Value}
                    onChange={(e) => {
                        props.onInputChange("MaritalStatus", props.PersonalDataForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("MaritalStatus", props.PersonalDataForm, e.target.value);
                    }}
                    error={props.PersonalDataForm.MaritalStatus.Error}
                />
            </Grid>

            <Grid item xs={6} sm={6}>
                <Controls.Input
                    name="MotherName"
                    label="Nome da Mãe"
                    maxLength={60}
                    placeholder={"Digite o nome da Mãe"}
                    value={props.PersonalDataForm.MotherName.Value}
                    onChange={(e) => {
                        props.onInputChange("MotherName", props.PersonalDataForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("MotherName", props.PersonalDataForm, e.target.value);
                    }}
                    error={props.PersonalDataForm.MotherName.Error}
                />
            </Grid>

            <Grid item xs={6} sm={6}>
                <Controls.Input
                    name="FatherName"
                    label="Nome do Pai"
                    maxLength={60}
                    placeholder={"Digite o nome do Pai"}
                    value={props.PersonalDataForm.FatherName.Value}
                    onChange={(e) => {
                        props.onInputChange("FatherName", props.PersonalDataForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("FatherName", props.PersonalDataForm, e.target.value);
                    }}
                    error={props.PersonalDataForm.FatherName.Error}
                />
            </Grid>

            <Grid item xs={6} sm={6}>
                <Controls.Input
                    name="PartnerName"
                    label="Cônjuge"
                    maxLength={60}
                    placeholder={"Digite o nome do Cônjuge"}
                    value={props.PersonalDataForm.PartnerName.Value}
                    onChange={(e) => {
                        props.onInputChange("PartnerName", props.PersonalDataForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("PartnerName", props.PersonalDataForm, e.target.value);
                    }}
                    error={props.PersonalDataForm.PartnerName.Error}
                />
            </Grid>

            <Grid item xs={6} sm={6}>
                <Controls.Input
                    name="UsualName"
                    label="Nome usual (crachá) *"
                    maxLength={60}
                    placeholder={"Digite seu nome usual, que vai aparecer no seu crachá"}
                    value={props.PersonalDataForm.UsualName.Value}
                    onChange={(e) => {
                        props.onInputChange("UsualName", props.PersonalDataForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("UsualName", props.PersonalDataForm, e.target.value);
                    }}
                    error={props.PersonalDataForm.UsualName.Error}
                />
            </Grid>

            <Grid item xs={6} sm={6}>
                <Controls.MuiPhoneInput
                    name="CellPhone"
                    label="Celular *"
                    type={InputPhoneType.CELULAR}
                    value={props.PersonalDataForm.CellPhone.Value}
                    onChange={(e) => {
                        props.onInputChange("CellPhone", props.PersonalDataForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("CellPhone", props.PersonalDataForm, e.target.value);
                    }}
                    error={props.PersonalDataForm.CellPhone.Error}
                />
            </Grid>

            <Grid item xs={6} sm={6}>
                <Controls.MuiPhoneInput
                    name="TelephonePhone"
                    label="Telefone Fixo"
                    type={InputPhoneType.TELEFONE}
                    value={props.PersonalDataForm.TelephonePhone.Value}
                    onChange={(e) => {
                        props.onInputChange("TelephonePhone", props.PersonalDataForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("TelephonePhone", props.PersonalDataForm, e.target.value);
                    }}
                    error={props.PersonalDataForm.TelephonePhone.Error}
                />
            </Grid>

            <Grid item xs={6} sm={6}>
                <Controls.MuiPhoneInput
                    name="BusinessPhone"
                    label="Telefone Comercial"
                    type={InputPhoneType.TELEFONE}
                    value={props.PersonalDataForm.BusinessPhone.Value}
                    onChange={(e) => {
                        props.onInputChange("BusinessPhone", props.PersonalDataForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("BusinessPhone", props.PersonalDataForm, e.target.value);
                    }}
                    error={props.PersonalDataForm.BusinessPhone.Error}
                />
            </Grid>

            <Grid item xs={6} sm={6}>
                <Controls.Input
                    name="Email"
                    label="E-mail *"
                    maxLength={255}
                    placeholder={"Digite seu e-mail"}
                    value={props.PersonalDataForm.Email.Value}
                    onChange={(e) => {
                        props.onInputChange("Email", props.PersonalDataForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("Email", props.PersonalDataForm, e.target.value);
                    }}
                    error={props.PersonalDataForm.Email.Error}
                />
            </Grid>

            <Grid item xs={6} sm={6}>
                <Controls.Autocomplete
                    label="Idiomas que domina"
                    name="Language"
                    multiple={true}
                    placeholder={"Digite os idiomas que você domina"}
                    options={languageStateOptions}
                    multiValue={props.PersonalDataForm.Language.Value}
                    onChange={(e) => {
                        props.onInputChange("Language", props.PersonalDataForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("Language", props.PersonalDataForm, e.target.value);
                    }}
                    error={props.PersonalDataForm.Language.Error}
                />
            </Grid>

        </Grid>

    )

}